<template>
  <div>
    <modal-processing
        v-if="canGenerateOS"
        :showModal="showModalOsProcessing"
        @confirmed="closeModalOsProcessing()"
    />

    <modal-observacoes-agendamento
        :modal-show="modalObservation.modalShow"
        :info-text="modalObservation.infoText"
        :close-modal.sync="modalObservation.modalShow"
    />

    <main class="card hidden_overflow_tabela">
      <div
          v-if="canInsert"
          class="pb-2 px-2 mt-2"
      >
        <b-button
            variant="primary-button"
            @click="redirectToRegister()"
        >
          <feather-icon
              icon="PlusIcon"
              class="mr-50"
          />
          <span class="align-middle">Adicionar novo Agendamento</span>
        </b-button>
      </div>

      <FilterAgendamentoList
          @filterTable="loadScheduleData"
          :filter="filter"
          :parameters="setParams"
          :paginationTotalLines="paginationData.totalLines"
          :tableItemsLength="table.items.length"
          :errorApi="errorApiSearchParameters"
      />
      <div
          v-if="loadingData"
          class="d-flex justify-content-center my-3"
      >
        <div
            class="spinner-border text-custom-blue"
            role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <section
          v-if="!loadingData"
          class="list-agendamento"
      >
        <b-table
            id="tableAgendamento"
            responsive
            :sticky-column="true"
            :busy.sync="filtering"
            :fields="table.fields"
            :items="table.items"
            no-local-sorting
            :no-sort-reset="true"
            @sort-changed="sortColumn"
        >
          <template #cell(criacao)="row">
            <div class="width_columns">
              <div class="font-weight-bolder">
                {{ formatDate(row.item.criacao) }}
              </div>
              <div>
                Agendamentos
              </div>
              <div>
                {{ getFullYearLocal(row.item.data_aplicacao) }}:
                <span class="font-weight-bold">
                  {{ row.item.total_agendamentos_ano_aplicacao }}
                </span>
              </div>
            </div>
          </template>
          <template #cell(nome_fantasia)="row">
            <div class="width_columns">
              <div
                  v-b-tooltip
                  class="font-weight-bolder"
                  :title="row.item.cnpj.length > lengthColumnMaximo ? row.item.cnpj : null"
              >
                {{ formatDocument(row.item.cnpj) }}
              </div>
              <div
                  v-b-tooltip
                  :title="row.item.razao_social.length > lengthColumnMaximo ? row.item.razao_social : null"
              >
                {{ row.item.razao_social }}
              </div>
              <div
                  v-b-tooltip
                  class="font-weight-bold"
                  :title="row.item.nome_fantasia.length > lengthColumnMaximo ? row.item.nome_fantasia : null"
              >
                {{ row.item.nome_fantasia }}
              </div>
            </div>
          </template>
          <template #cell(unidade_descricao)="row">
            <span
                v-b-tooltip
                class="width_columns"
                :title="row.item.descricao && row.item.descricao.length > lengthColumnMaximo ? row.item.descricao : null"
            >
              {{ row.item.unidade_descricao }}
            </span>
          </template>
          <template #cell(data_aplicacao)="row">
            <div class="width_columns">
              <div
                  v-if="row.item.data_aplicacao == row.item.data_final_aplicacao || !row.item.data_final_aplicacao"
              >
                {{ formatDate(row.item.data_aplicacao) }}
              </div>
              <div v-else>
                {{ formatDate(row.item.data_aplicacao) }} - {{ formatDate(row.item.data_final_aplicacao) }}
              </div>
              <div
                  v-b-tooltip
                  class="littleLabelScheduling"
                  :title="null"
              >
                {{ getPeriod(row.item) }}
              </div>
            </div>
          </template>
          <template #cell(quantidade_dose_prevista)="row">
            <span
                v-b-tooltip
                class="width_columns"
                :title="row.item.quantidade_dose_prevista && row.item.quantidade_dose_prevista.length > lengthColumnMaximo ? row.item.quantidade_dose_prevista : null"
            >
              {{ row.item.agendamento_vacina.length ? row.item.dose_prevista : 0 }}
            </span>
          </template>
          <template #cell(quantidade_dose_aplicada)="row">
            <span
                v-b-tooltip
                class="width_columns"
                :title="row.item.quantidade_dose_aplicada && row.item.quantidade_dose_aplicada.length > lengthColumnMaximo ? row.item.quantidade_dose_aplicada : null"
            >
              {{ row.item.agendamento_vacina.length ? row.item.quantidade_dose_aplicada ? row.item.quantidade_dose_aplicada.toLocaleString('pt-BR') : '-' : 0 }}
            </span>
          </template>
          <template #cell(situacao)="row">
            <span
                v-b-tooltip
                class="width_columns"
                :class="{
                'customStatusAgendado': row.item.situacao === 'Agendado',
                'customStatusFinalizado': row.item.situacao === 'Finalizado',
                'customStatusCancelado': row.item.situacao === 'Cancelado',
                'customStatusRepescagem': row.item.situacao === 'Repescagem'
              }"
                :title="row.item.situacao && row.item.situacao.length > lengthColumnMaximo ? row.item.situacao : null"
            >
              {{ row.item.situacao }}
            </span>
          </template>
          <template #cell(actions)="row">
            <div class="width_columns actions_column">
              <feather-icon
                  id="view-agendamento"
                  role="button"
                  class="text-custom-blue mr-1"
                  icon="EyeIcon"
                  size="18"
                  @click.prevent="modalObservations(row.item)"
              />
              <feather-icon
                  v-if="canEdit && (row.item.situacao == 'Agendado' || row.item.situacao == 'Repescagem')"
                  id="edit-agendamento"
                  role="button"
                  class="text-custom-blue mr-1"
                  icon="EditIcon"
                  size="18"
                  @click.prevent="redirectToEdit(row.item)"
              />
              <feather-icon
                  v-if="canGenerateOS && row.item.situacao != 'Cancelado' && !loadingOS[row.item.id_agendamento]"
                  id="download-os"
                  role="button"
                  class="text-custom-blue"
                  icon="DownloadIcon"
                  size="18"
                  @click.prevent="generateOS(row.item.id_agendamento)"
                />
              <b-spinner v-else-if="canGenerateOS && row.item.situacao !== 'Cancelado' && loadingOS[row.item.id_agendamento]" small class="text-custom-blue" />
            </div>
          </template>
        </b-table>
        <div class="pb-2 px-1">
          <span
              v-if="withoutAgendamento"
              class="ml-1"
          >Nenhum agendamento encontrado</span>
          <b-col
              sm="12"
              class="mt-2"
          >
            <CustomPagination
                :paginacao="paginationData"
                @page-cliked="updateCurrentPage"
            />
          </b-col>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import {
  BForm, BCol, BRow, BFormGroup, BFormInput, BButton, BTable, BFormDatepicker, BInputGroup, BInputGroupAppend, BSpinner
} from 'bootstrap-vue'
import moment from 'moment'
import vSelect from 'vue-select'
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue'
import { actions, subjects } from '@/libs/acl/rules'
import ModalObservacoesAgendamento from '@/views/components/custom/modals/ObservacoesAgendamento.vue'
import FilterAgendamentoList from '@/views/custom-pages/agendamento/components/FilterAgendamentoList.vue'
import ModalProcessing from "@/views/components/custom/modals/agendamento/ordem-de-servico/ModalProcessing.vue";

export default {
  title: 'Agendamentos',

  components: {
    BForm,
    BSpinner,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    CustomPagination,
    vSelect,
    ModalObservacoesAgendamento,
    FilterAgendamentoList,
    ModalProcessing
  },

  data() {
    return {
      searchParameters: {
        cnpj: null,
        fantasyName: null,
        date: null,
      },
      errorApiSearchParameters: {
        cnpj: null,
        fantasyName: null,
        date: null,
      },
      filter: false,
      inputDateStart: null,
      inputDateEnd: null,
      filtering: false,
      canInsert: this.verifyPermissions(actions.INSERIR),
      canEdit: this.verifyPermissions(actions.ATUALIZAR),
      canGenerateOS:
          this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI) ||
          this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI_SAUDE_REGIAO),
      loadingData: false,
      loadingOS: {},
      paginationData: {
        currentPage: 1,
        totalLines: 0,
        fromLine: 0,
        toLine: 0,
        defaultSize: 10,
      },
      table: {
        fields: [
          {
            key: 'criacao', label: 'DATA DE CRIAÇÃO', sortable: true, class: 'width_columns width_columns_header width_columns_header_company',
          },
          {
            key: 'nome_fantasia', label: 'EMPRESA', sortable: true, class: 'width_columns width_columns_header width_columns_header_company',
          },
          {
            key: 'unidade_descricao', label: 'UNIDADE OPERACIONAL', sortable: true, class: 'width_columns width_columns_header',
          },
          {
            key: 'data_aplicacao', label: 'DATA', sortable: true, class: 'width_columns width_columns_header',
          },
          {
            key: 'quantidade_dose_prevista', label: 'DOSES PREVISTAS', sortable: true, class: 'width_columns width_columns_header',
          },
          {
            key: 'quantidade_dose_aplicada', label: 'DOSES APLICADAS', sortable: true, class: 'width_columns width_columns_header',
          },
          {
            key: 'situacao', label: 'STATUS', sortable: true, class: 'width_columns_small width_columns_header',
          },
          {
            key: 'actions', label: 'AÇÕES', sortable: false, class: 'width_columns_small width_columns_header',
          },
        ],
        items: [],
        optionsSize: [10, 25, 50, 100],
        columnOrder: 'data_aplicacao',
        order: 'desc',
      },
      withoutAgendamento: false,
      modalObservation: {
        modalShow: false,
        infoText: 'Nenhuma observação encontrada.',
      },
      lengthColumnMaximo: 28,
      errors: null,
      searchParams: null,
      showModalOsProcessing: false,
      initialCountProcessedOS: 0
    }
  },

  computed: {
    setParams() {
      const filters = this.searchParams || {}

      return {
        cnpj: filters.cnpj ?? null,
        nome_fantasia: filters.nome_fantasia ?? null,
        company_name_filter: filters.company_name_filter ?? null,
        data_inicio_aplicacao: filters.data_inicio ?? null,
        data_fim_aplicacao: filters.data_fim ?? null,
        situacao: filters.status ?? null,
        unidade_operacional: filters.unidade_operacional ?? null,
        departamento: filters.departamento ?? null,
        campanha: filters.campanha ?? null,

        pagina: filters.pagina ?? this.paginationData.currentPage,
        porPagina: filters.porPagina ?? this.paginationData.defaultSize,

        colunaNome: this.table.columnOrder,
        colunaOrdem: this.table.order,

        route: this.$router.currentRoute.name,
      }
    },
  },

  methods: {
    formatDocument(document) {
      return this.$options.filters.formataCpfCnpj(document)
    },
    redirectToRegister() {
      this.$router.push({ name: 'agendamento-register' })
    },

    verifyPermissions(action) {
      const permission = this.$can(actions[action], subjects.AGENDAMENTO_SESI) || this.$can(actions[action], subjects.AGENDAMENTO_SESI_UO)

      return [permission].includes(true)
    },

    sortColumn(sort) {
      this.table.columnOrder = sort.sortBy
      this.table.order = sort.sortDesc ? 'desc' : 'asc'
      this.loadScheduleData()
    },

    updateCurrentPage(page) {
      this.paginationData.currentPage = page
      this.filter = !this.filter
    },

    redirectToEdit({ id_agendamento }) {
      this.$router.push(
          {
            name: 'agendamento-edit',
            params: {
              idAgendamento: id_agendamento,
            },
          },
      )
    },

    generateOS(idAgendamento) {
      this.$set(this.loadingOS, idAgendamento, true);
      this.$toast.success('Gerando ordem de serviço, por favor aguarde...');
      this.getInitialCountProcessedOS();

      this.$http.get(this.$api.getOSByAgendamentoId(idAgendamento), { responseType: 'blob' })
          .then(response => {
            const type = response.headers['content-type'];
            if (type.includes('application/pdf')) {
              const blob = new Blob([response.data], { type });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `ordem_de_servico_${idAgendamento}.pdf`;
              link.click();
              URL.revokeObjectURL(link.href);
            } else {
              response.data.text().then(() => {
                this.showModalOsProcessing = true;
                this.iniciarPollingOSProcessed();
              });
            }
          })
          .catch(error => {
            if (error.response && error.response.data) {
              const blob = error.response.data;

              blob.text().then(text => {
                let json = {};
                json = JSON.parse(text);
                this.$toast.error(json.errors || "Erro ao gerar ordem de serviço");
              });

            } else {
              this.$toast.error("Erro inesperado ao gerar ordem de serviço");
            }
          })
          .finally(() => this.$set(this.loadingOS, idAgendamento, false));
    },
    getInitialCountProcessedOS() {
      this.$http.get(this.$api.getOSProcessedByUser()).then(({ data }) => {
        this.initialCountProcessedOS = data.length;
      })
    },
    iniciarPollingOSProcessed() {
      this.pollingInterval = setInterval(() => {
        this.verifyNewsOSProcessed();
      }, 10000)
    },
    verifyNewsOSProcessed() {
      this.$http.get(this.$api.getOSProcessedByUser()).then(({ data }) => {
        if(data.length > this.initialCountProcessedOS) {
          window.location.reload();
        }
      })
    },

    modalObservations(item) {
      this.modalObservation.infoText = item.observacao || item.observacao == '' ? item.observacao : 'Nenhuma observação encontrada.'
      this.modalObservation.modalShow = true
    },

    loadScheduleData(filter = null) {
      if (filter) {
        this.searchParams = filter
        this.paginationData.defaultSize = filter.porPagina ?? this.paginationData.defaultSize
        this.paginationData.currentPage = filter.currentPage ?? this.paginationData.currentPage
      }

      this.filtering = true
      this.errorApiSearchParameters = {
        cnpj: null,
        fantasyName: null,
        date: null,
      }

      this.$http
          .get(this.$api.getAndPostAgendamento(), { params: this.setParams })
          .then(({ data }) => {
            this.table.items = data.data
            this.withoutAgendamento = data.data.length === 0
            this.startPagination(data)
          })
          .catch(({ response: { data } }) => {
            const error = data.errors || {}
            this.errorApiSearchParameters.cnpj = error.cnpj?.[0] || ''
          })
          .finally(() => {
            this.filtering = false
          })
    },

    startPagination(data) {
      this.paginationData.currentPage = data.current_page
      this.paginationData.totalLines = data.total
      this.paginationData.fromLine = data.from
      this.paginationData.toLine = data.to
      this.paginationData.defaultSize = data.per_page
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getFullYearLocal(dateString) {
      const [year, month, day] = dateString.split('-').map(Number)
      return new Date(year, month - 1, day).getFullYear()
    },
    getPeriod(item) {
      let periodo
      if (item.agendamento_periodos.length > 0) {
        periodo = []
        item.agendamento_periodos.forEach(period => periodo.push(period.descricao))
      } else {
        periodo = item.periodo
      }

      let resultPeriod
      if (Array.isArray(periodo)) {
        resultPeriod = periodo.join('/')
      } else {
        resultPeriod = periodo
      }

      return resultPeriod
    },
    closeModalOsProcessing() {
      this.showModalOsProcessing = false;
    }
  },
}
</script>

<style lang="scss" scoped>
.spacing-top-buttons {
  margin-top: 6px;
}
.min-width-label{
  min-width: 250px;
}
.min-width-date{
  min-width: 200px;
}
.min-width-button-search {
  min-width: 140px;
}
.min-width-button-reset {
  min-width: 120px;
}
.customStatusAgendado {
  align-items: center;
  padding: 1px 9px;
  gap: 3px;
  width: 83px;
  height: 20px;
  background: #F3EEFF;
  border-radius: 17px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #8C65E2;
}
.customStatusFinalizado {
  padding: 3px 9px;
  background: rgba(40, 199, 111, 0.12);
  border-radius: 17px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #3AAA4E;
}
.customStatusCancelado {
  align-items: center;
  padding: 1px 9px;
  gap: 3px;
  width: 83px;
  height: 20px;
  background: #fceaea;
  border-radius: 17px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #EA5555;
}
.customStatusRepescagem {
  align-items: center;
  padding: 1px 9px;
  gap: 3px;
  width: 83px;
  height: 20px;
  background: #fff3e8;
  border-radius: 17px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ff9f43;
}
.companyScheduling {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 21px;
  color: #5E5873;
}
.littleLabelScheduling {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  font-weight: bold;
}
@media (max-width: 350px) {
  .min-width-button-search {
    min-width: 100px;
  }
  .min-width-button-reset {
    min-width: 100px;
  }
}
.hidden_overflow_tabela{
  overflow: hidden;
}
.width_columns_small{
  min-width: 140px;
  max-width: 140px;
  text-align: left;
}
.width_columns{
  text-align: left;
}
@media (min-width: 1050px) {
  .actions_column{
    display: flex;
    align-items: center;
  }
}
.width_columns_header_company{
  min-width: 220px;
}
.width_columns_header{
  vertical-align: middle !important;
}
</style>
